import React, { useState, useEffect } from "react";
import { IoIosClose } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import RequestService from '../../services/RequestService';

export default function QualificacaoModal({
  isModalOpen,
  setModalOpen,
  requestId
}) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue
  } = useForm();

  const [requestObject, setRequestObject] = useState();

  useEffect(() => {
    async function fetchRequest() {
      const request = await RequestService.getRequestById(requestId);
      setRequestObject(request);
      // Preenche valores iniciais se já houver qualificação
      if (request?.request?.qualificacao) {
        Object.entries(request.request.qualificacao).forEach(([key, value]) => {
          setValue(key, value);
        });
      }
    }
    if (isModalOpen) fetchRequest();
  }, [isModalOpen, requestId, setValue]);

  const onSubmit = async (data) => {
    try {
      const response = await RequestService.updateQualificacao(requestId, data);
      if (response) {
        toast.success('Qualificação salva com sucesso!', { autoClose: 5000 });
        setModalOpen(false);
        reset();
      } else {
        toast.error('Erro ao salvar qualificação.', { autoClose: 5000 });
      }
    } catch (error) {
      toast.error(error?.message || 'Erro ao salvar qualificação.', { autoClose: 5000 });
    }
  };

  const onClose = () => {
    setModalOpen(false);
    reset();
  };

  if (!isModalOpen) return null;

  return (
    <div className="flex flex-col relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto py-8" onClick={onClose}>
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div className="flex flex-col max-w-[700px] h-fit pb-4 relative transform rounded-lg bg-white text-left shadow-xl transition-all" onClick={e => e.stopPropagation()}>
            <button onClick={onClose} className="absolute -top-7 -right-7 rounded-full p-1">
              <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                <IoIosClose color={"black"} size={32} />
              </div>
            </button>
            <div className="flex flex-col px-4 pt-4 pb-3 text-left gap-2 bg-gray-800 text-white rounded-t-lg">
              <div className="flex gap-2 items-center text-white text-xl font-bold">
                Qualificação do Chamado
              </div>
              <div className="ms-4 flex justify-between">
                <div className="text-sm">Solicitação nº: {requestObject?.request?.idRequest}</div>
                <div className="text-sm">Criado em: {requestObject?.request?.createdAt && new Date(requestObject.request.createdAt).toLocaleString()}</div>
              </div>
            </div>
            <form className="flex flex-col mt-6 px-4 text-xs gap-4" onSubmit={handleSubmit(onSubmit)}>
              {/* Baixa SIGTM */}
              <div className="flex flex-col gap-2">
                <label className="font-bold">Baixa do Chamado no SIGTM</label>
                <div className="flex items-center gap-2">
                  <input type="checkbox" {...register("baixadoSigtm" )} id="baixadoSigtm" />
                  <label htmlFor="baixadoSigtm">Item baixado no SIGTM</label>
                </div>
                <div className="flex gap-2">
                  <input type="datetime-local" {...register("dataHoraBaixaSigtm" )} className="border rounded px-2" />
                  <input type="text" placeholder="Observação" {...register("obsBaixaSigtm" )} className="border rounded px-2" />
                </div>
              </div>
              {/* Vendor */}
              <div className="flex flex-col gap-2">
                <label className="font-bold">Conferência no site dos VENDORS</label>
                <div className="flex items-center gap-2">
                  <input type="checkbox" {...register("unidadeAtivaVendor" )} id="unidadeAtivaVendor" />
                  <label htmlFor="unidadeAtivaVendor">Unidade ativa na plataforma</label>
                </div>
                <div className="flex gap-2">
                  <input type="datetime-local" {...register("dataHoraInstalacaoVendor" )} className="border rounded px-2" />
                </div>
              </div>
              {/* Site */}
              <div className="flex flex-col gap-2">
                <label className="font-bold">Instalação no Site</label>
                <div className="flex items-center gap-2">
                  <input type="checkbox" {...register("instaladaNoMesmoSite" )} id="instaladaNoMesmoSite" />
                  <label htmlFor="instaladaNoMesmoSite">Instalada no mesmo site</label>
                </div>
                <div className="flex gap-2">
                  <input type="text" placeholder="Site instalado (caso não seja o original)" {...register("siteInstalado" )} className="border rounded px-2" />
                </div>
              </div>
              <button type="submit" className="w-full bg-blue-500 text-white py-2 px-4 rounded-2xl hover:bg-blue-600 mt-4">
                Salvar Qualificação
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
